export const welcomeStyles = {
  welcomeLayer: {
    width: "100%",
    height: "200px",
    p: "41px",
    background:
      "linear-gradient(180deg, #21B8F9 0%, rgba(33, 184, 249, 0) 132.05%)",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  welcomeText: {
    fontWeight: 600,
    fontSize: "34px",
    lineHeight: "39px",
    color: "#FFFFFF",
  },
  welcomeLinks: {
    display: "flex",
    justifyContent: "center",
    mt: "7px",
    color: "#FFFFFF",
    cursor: "pointer",
  },
  welcomeLink: {
    fontWeight: 500,
    fontSize: "17px",
    lineHeight: "22px",
    textDecorationLine: "underline",
  },
  welcomeIcon: {
    marginLeft: "16px",
  },
};
